import { RouteInfo } from './sidebar.metadata';
export const ROUTES: RouteInfo[] = [
  // {
  //   path: "",
  //   title: "MENUITEMS.MAIN.TEXT",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   submenu: [],
  // },

  // Admin Modules
  {
    path: '/admin/dashboard/main',
    title: 'MENUITEMS.DASHBOARD.TEXT',
    iconType: 'material-icons',
    automationId: 'dashboard',
    icon: 'dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['MaleMan Admin', 'Super Admin', 'Admin', 'Lab Technician', 'Buyer','Physician'],
    submenu: [],
    svgd: 'M15.8333 4.16667V5.83333H12.5V4.16667H15.8333ZM7.5 4.16667V9.16667H4.16667V4.16667H7.5ZM15.8333 10.8333V15.8333H12.5V10.8333H15.8333ZM7.5 14.1667V15.8333H4.16667V14.1667H7.5ZM17.5 2.5H10.8333V7.5H17.5V2.5ZM9.16667 2.5H2.5V10.8333H9.16667V2.5ZM17.5 9.16667H10.8333V17.5H17.5V9.16667ZM9.16667 12.5H2.5V17.5H9.16667V12.5Z',
  },

  {
    path: '/shop/maleman',
    title: 'Order MaleMan',
    automationId: 'shop',
    iconType: 'material-icons',
    icon: 'local_mall',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['MaleMan Admin', 'Super Admin', 'Admin', 'Lab Technician', 'Buyer','Physician'],
    subRoute: '/products/product',
    submenu: [],
    svgd: 'M15.8333 4.99992H14.1667C14.1667 2.69992 12.3 0.833252 10 0.833252C7.7 0.833252 5.83333 2.69992 5.83333 4.99992H4.16667C3.25 4.99992 2.5 5.74992 2.5 6.66658V16.6666C2.5 17.5833 3.25 18.3333 4.16667 18.3333H15.8333C16.75 18.3333 17.5 17.5833 17.5 16.6666V6.66658C17.5 5.74992 16.75 4.99992 15.8333 4.99992ZM10 2.49992C11.3833 2.49992 12.5 3.61659 12.5 4.99992H7.5C7.5 3.61659 8.61667 2.49992 10 2.49992ZM15.8333 16.6666H4.16667V6.66658H15.8333V16.6666ZM10 9.99992C8.61667 9.99992 7.5 8.88325 7.5 7.49992H5.83333C5.83333 9.79992 7.7 11.6666 10 11.6666C12.3 11.6666 14.1667 9.79992 14.1667 7.49992H12.5C12.5 8.88325 11.3833 9.99992 10 9.99992Z',
  },

  // Doctor Modules
  {
    path: '/doctor/dashboard',
    title: 'MENUITEMS.DASHBOARD.LIST.DOCTOR-DASHBOARD',
    iconType: 'material-icons',
    icon: 'space_dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [],
    submenu: [],
  },

  // Patient Modules
  {
    path: '/patient/dashboard',
    title: 'MENUITEMS.DASHBOARD.LIST.PATIENT-DASHBOARD',
    iconType: 'material-icons',
    icon: 'space_dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [],
    submenu: [],
  },

  {
    path: '/maleman/status',
    title: 'MaleMan Status',
    automationId: 'MaleManStatus',

    iconType: 'material-icons',
    icon: 'assignment_turned_in',
    //class: "menu-toggle",
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['MaleMan Admin', 'Super Admin', 'Admin', 'Lab Technician', 'Buyer','Physician'],
    submenu: [],
    svgd: 'M15 7.49992L13.825 6.31659L8.33333 11.8083L6.175 9.65825L5 10.8333L8.33333 14.1666L15 7.49992ZM15.8333 2.49992H12.35C12 1.53325 11.0833 0.833252 10 0.833252C8.91667 0.833252 8 1.53325 7.65 2.49992H4.16667C4.05 2.49992 3.94167 2.50825 3.83333 2.53325C3.50833 2.59992 3.21667 2.76659 2.99167 2.99159C2.84167 3.14159 2.71667 3.32492 2.63333 3.52492C2.55 3.71659 2.5 3.93325 2.5 4.16659V15.8333C2.5 16.0583 2.55 16.2833 2.63333 16.4833C2.71667 16.6833 2.84167 16.8583 2.99167 17.0166C3.21667 17.2416 3.50833 17.4083 3.83333 17.4749C3.94167 17.4916 4.05 17.4999 4.16667 17.4999H15.8333C16.75 17.4999 17.5 16.7499 17.5 15.8333V4.16659C17.5 3.24992 16.75 2.49992 15.8333 2.49992ZM10 2.29159C10.3417 2.29159 10.625 2.57492 10.625 2.91659C10.625 3.25825 10.3417 3.54159 10 3.54159C9.65833 3.54159 9.375 3.25825 9.375 2.91659C9.375 2.57492 9.65833 2.29159 10 2.29159ZM15.8333 15.8333H4.16667V4.16659H15.8333V15.8333Z',
  },
  {
    path: '/orders/history',
    title: 'Order History',
    automationId: 'OrderHistory',
    iconType: 'material-icons',
    icon: 'history',
    //class: "menu-toggle",
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['MaleMan Admin', 'Super Admin', 'Admin', 'Lab Technician', 'Buyer','Physician'],
    submenu: [],
    subRoute: '/orders/review',
  },
  {
    path: '/MaleMan-settings/settings',
    title: 'Settings',
    automationId: 'settings',
    iconType: 'material-icons',
    icon: 'settings',
    //class: "menu-toggle",
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Super Admin', 'Admin', 'Lab Technician', 'Buyer','Physician'],
    submenu: [],
    svgd: 'M16.1915 10.8167C16.2249 10.5501 16.2499 10.2834 16.2499 10.0001C16.2499 9.71675 16.2249 9.45008 16.1915 9.18341L17.9499 7.80841C18.1082 7.68341 18.1499 7.45841 18.0499 7.27508L16.3832 4.39175C16.3082 4.25841 16.1665 4.18341 16.0165 4.18341C15.9665 4.18341 15.9165 4.19175 15.8749 4.20841L13.7999 5.04175C13.3665 4.70841 12.8999 4.43341 12.3915 4.22508L12.0749 2.01675C12.0499 1.81675 11.8749 1.66675 11.6665 1.66675H8.3332C8.12487 1.66675 7.94987 1.81675 7.92487 2.01675L7.6082 4.22508C7.09987 4.43341 6.6332 4.71675 6.19987 5.04175L4.12487 4.20841C4.07487 4.19175 4.02487 4.18341 3.97487 4.18341C3.8332 4.18341 3.69153 4.25841 3.61653 4.39175L1.94987 7.27508C1.84153 7.45841 1.89153 7.68341 2.04987 7.80841L3.8082 9.18341C3.77487 9.45008 3.74987 9.72508 3.74987 10.0001C3.74987 10.2751 3.77487 10.5501 3.8082 10.8167L2.04987 12.1917C1.89153 12.3167 1.84987 12.5417 1.94987 12.7251L3.61653 15.6084C3.69153 15.7417 3.8332 15.8167 3.9832 15.8167C4.0332 15.8167 4.0832 15.8084 4.12487 15.7917L6.19987 14.9584C6.6332 15.2917 7.09987 15.5667 7.6082 15.7751L7.92487 17.9834C7.94987 18.1834 8.12487 18.3334 8.3332 18.3334H11.6665C11.8749 18.3334 12.0499 18.1834 12.0749 17.9834L12.3915 15.7751C12.8999 15.5667 13.3665 15.2834 13.7999 14.9584L15.8749 15.7917C15.9249 15.8084 15.9749 15.8167 16.0249 15.8167C16.1665 15.8167 16.3082 15.7417 16.3832 15.6084L18.0499 12.7251C18.1499 12.5417 18.1082 12.3167 17.9499 12.1917L16.1915 10.8167ZM14.5415 9.39175C14.5749 9.65008 14.5832 9.82508 14.5832 10.0001C14.5832 10.1751 14.5665 10.3584 14.5415 10.6084L14.4249 11.5501L15.1665 12.1334L16.0665 12.8334L15.4832 13.8417L14.4249 13.4167L13.5582 13.0667L12.8082 13.6334C12.4499 13.9001 12.1082 14.1001 11.7665 14.2417L10.8832 14.6001L10.7499 15.5417L10.5832 16.6667H9.41653L9.2582 15.5417L9.12487 14.6001L8.24153 14.2417C7.8832 14.0917 7.54987 13.9001 7.21653 13.6501L6.4582 13.0667L5.57487 13.4251L4.51653 13.8501L3.9332 12.8417L4.8332 12.1417L5.57487 11.5584L5.4582 10.6167C5.4332 10.3584 5.41653 10.1667 5.41653 10.0001C5.41653 9.83341 5.4332 9.64175 5.4582 9.39175L5.57487 8.45008L4.8332 7.86675L3.9332 7.16675L4.51653 6.15841L5.57487 6.58341L6.44153 6.93341L7.19153 6.36675C7.54987 6.10008 7.89153 5.90008 8.2332 5.75841L9.11653 5.40008L9.24987 4.45841L9.41653 3.33341H10.5749L10.7332 4.45841L10.8665 5.40008L11.7499 5.75841C12.1082 5.90841 12.4415 6.10008 12.7749 6.35008L13.5332 6.93341L14.4165 6.57508L15.4749 6.15008L16.0582 7.15841L15.1665 7.86675L14.4249 8.45008L14.5415 9.39175ZM9.99987 6.66675C8.1582 6.66675 6.66653 8.15841 6.66653 10.0001C6.66653 11.8417 8.1582 13.3334 9.99987 13.3334C11.8415 13.3334 13.3332 11.8417 13.3332 10.0001C13.3332 8.15841 11.8415 6.66675 9.99987 6.66675ZM9.99987 11.6667C9.0832 11.6667 8.3332 10.9167 8.3332 10.0001C8.3332 9.08341 9.0832 8.33341 9.99987 8.33341C10.9165 8.33341 11.6665 9.08341 11.6665 10.0001C11.6665 10.9167 10.9165 11.6667 9.99987 11.6667Z',
  },
  // {
  //   path: '/maleman-kit/batch',
  //   title: 'Service',
  //   automationId: 'service',
  //   iconType: 'material-icons',
  //   icon: 'build',
  //   //class: "menu-toggle",
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: ['MaleMan Admin'],
  //   submenu: [],
  // },
  // {
  //   path: '/facility-management/customers',
  //   title: 'Facility Management',
  //   automationId: 'FacilityManagement',
  //   iconType: 'material-icons',
  //   icon: 'supervised_user_circle',
  //   //class: "menu-toggle",
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: ['MaleMan Admin'],
  //   submenu: [],
  // },
];
